import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Divider,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDButton from "theme/components/MDButton";
// import MDInput from "theme/components/MDInput";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import axios from "axios.js";
import AppConfig from "appConfig";
import usePageTitle from "app/pageTitle";
import MDInput from "theme/components/MDInput";

function LeadBucketsPage() {
  const pageTitle = "Lead Buckets";
  usePageTitle(pageTitle);

  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [buckets, setBuckets] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get("agents/leads/buckets.json")
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setBuckets(result.data.data.buckets);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine
                ? ""
                : "Make sure you have an active internet connection"
            }`,
          );
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  const [search, setSearch] = useState("");

  const filteredBuckets = buckets.filter((bucket) => {
    const value = search.toLowerCase();

    return (
      bucket.title?.toLowerCase().includes(value) ||
      bucket.lead_type?.toLowerCase().includes(value) ||
      bucket.account.name?.toLowerCase().includes(value)
    );
  });
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <MDBox mt={1} mb={5}>
        <MDBox mb={3}>
          <Card>
            <MDBox p={2}>
              <MDBox
                display="flex"
                justifyContent="space-between"
                px={1}
                mb={2}
              >
                <MDBox pt={0.5}>
                  <Icon>people</Icon>
                </MDBox>
                <MDBox>
                  <MDTypography variant="caption" fontWeight="regular">
                    Lead Buckets
                  </MDTypography>
                </MDBox>
              </MDBox>
              <MDBox my={2} align="center">
                <MDInput
                  fullWidth
                  label="Search campaigns..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </MDBox>
            </MDBox>
          </Card>
        </MDBox>
        <MDBox mt={0}>
          {buckets.length > 0 ? (
            <MDBox>
              {filteredBuckets.map((bucket) => (
                <MDBox
                  mb={3}
                  onClick={() => {
                    navigate(`/leads/buckets/${bucket.reference}`);
                  }}
                >
                  <Card>
                    <MDBox p={1.5}>
                      <MDBox display="flex" justifyContent="space-between">
                        <MDBox>
                          <MDTypography variant="caption" fontWeight="regular">
                            {bucket.account.name}
                          </MDTypography>
                        </MDBox>
                        <MDBox pt={1}>
                          <Icon>east</Icon>
                        </MDBox>
                      </MDBox>
                      <Divider />
                      <MDBox display="flex" justifyContent="space-between">
                        <MDBox>
                          <MDTypography variant="h6" fontSize={16}>
                            {bucket.title}
                          </MDTypography>
                          <MDTypography
                            variant="h6"
                            fontSize={12}
                            fontWeight="regular"
                          >
                            {bucket.lead_type}
                          </MDTypography>
                        </MDBox>
                        <MDBox>
                          <img
                            src={`${AppConfig.api_media_url}${bucket.account.icon}`}
                            width="24px"
                          />
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
              ))}
            </MDBox>
          ) : (
            <Card>
              <MDBox align="center" p={2}>
                <MDTypography fontSize={48}>
                  <Icon>warning</Icon>
                </MDTypography>
                <MDTypography variant="body2">
                  You have not been added to any buckets yet.
                </MDTypography>
              </MDBox>
            </Card>
          )}
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default LeadBucketsPage;
